import React, { useState, useEffect } from 'react';

import { Menu } from '@material-ui/icons';

import { array, func, bool, object, string, oneOfType, number } from 'prop-types';

import HeaderSteps from '../../../../../../containers/HeaderSteps';
import { getCartId } from '../../../../../../redux/utils/cookies';
import Image from '../../../../../Image';
import HeaderDrawerMenu from '../../../../components/HeaderDrawerMenu';
import { FullContainer, Container } from '../../styles';

import HeaderInput from './HeaderInput';
import HeaderSearchBox from './HeaderSearchBox';
import HeaderUser from './HeaderUser';
import {
  Logo,
  LogoContainer,
  InputContainer,
  UserMenuContainer,
  ButtonIcon,
  LinkLogo,
  UserMenuContainerMobile,
} from './styles';

function HeaderMiddle({
  menu,
  openSearchBox,
  isSearchBox,
  cart,
  visibility,
  cartFreight,
  cartFreightRequest,
  isLoading,
  error,
  renderComponents,
  searchRequest,
  search,
  cartRequest,
  clearSearch,
  customerName,
  customerId,
  isMobile,
  domain,
  siteId,
  disabledInput,
}) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const cartId = getCartId() || cart.getIn(['id']);

  useEffect(() => {
    if (!renderComponents && cartId) cartRequest();
  }, [cartRequest, cartId, renderComponents]);

  const handleOpenDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  return (
    <FullContainer container mobile="true">
      <Container container>
        {isMobile && (
          <HeaderDrawerMenu open={openDrawer} onClose={handleOpenDrawer} menu={menu} customerName={customerName} />
        )}

        <LogoContainer renderComponents={renderComponents}>
          {!renderComponents && (
            <ButtonIcon mobile="true" onClick={handleOpenDrawer} title="Menu" aria-label="Menu">
              <Menu />
            </ButtonIcon>
          )}
          <LinkLogo href="/" title="Home">
            <Logo>
              <Image
                defaultSize={`https://cdn.smartbr.com/${siteId}/logotipo.png`}
                usePicture={false}
                lazyLoad={false}
                title="Home"
                alt="Home"
              />
            </Logo>
          </LinkLogo>
          {!renderComponents && (
            <UserMenuContainerMobile>
              <HeaderUser
                cart={cart}
                visibility={visibility}
                cartFreight={cartFreight}
                cartFreightRequest={cartFreightRequest}
                isLoading={isLoading}
                error={error}
                customerId={customerId}
                customerName={customerName}
                domain={domain}
                inputId="mobile-input-cart-freight"
              />
            </UserMenuContainerMobile>
          )}
        </LogoContainer>
        {!renderComponents && (
          <InputContainer>
            <HeaderInput
              openSearchBox={openSearchBox}
              searchRequest={searchRequest}
              clearSearch={clearSearch}
              disabledInput={disabledInput}
              isLoading={search.getIn(['isLoading'])}
            />
            <HeaderSearchBox open={isSearchBox} {...search} isLoading={search.isLoading} />
          </InputContainer>
        )}
        {!renderComponents && !isMobile && (
          <UserMenuContainer>
            <HeaderUser
              cart={cart}
              visibility={visibility}
              cartFreight={cartFreight}
              cartFreightRequest={cartFreightRequest}
              isLoading={isLoading}
              error={error}
              customerId={customerId}
              customerName={customerName}
              domain={domain}
            />
          </UserMenuContainer>
        )}
        {renderComponents && <HeaderSteps />}
      </Container>
    </FullContainer>
  );
}

HeaderMiddle.propTypes = {
  menu: array,
  openSearchBox: func,
  isSearchBox: bool,
  cart: object,
  visibility: bool,
  cartFreight: object,
  cartFreightRequest: func,
  isLoading: bool,
  error: object,
  renderComponents: bool,
  searchRequest: func,
  search: object,
  cartRequest: func,
  clearSearch: func,
  customerName: string,
  customerId: oneOfType([string, number]),
  isMobile: bool,
  asPath: string,
  domain: string,
  siteId: number,
  searchInput: bool,
  disabledInput: bool,
};

export default HeaderMiddle;
